import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron--right--custom-color",
  "use": "icon-chevron--right--custom-color-usage",
  "viewBox": "0 0 6 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 11\" id=\"icon-chevron--right--custom-color\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.35 5.06.148.854A.5.5 0 1 1 .854.148L5.41 4.705a.499.499 0 0 1 0 .709L.854 9.97a.5.5 0 0 1-.708-.707l4.205-4.205Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol